import { useQuery } from "@tanstack/react-query";
import { orgBillingApi, type PremiumDeal } from "@/api/org-billing-api";

// Fetches the org's premium (ai_tracked) deals for the downgrade selection
// modal. Gated by `enabled` so the list is only fetched while the modal is open.
export function usePremiumDeals(orgId: string | undefined, enabled: boolean) {
  const { data, isLoading, isError, error, refetch } = useQuery<PremiumDeal[]>({
    queryKey: ["orgPremiumDeals", orgId],
    queryFn: () => orgBillingApi.getPremiumDeals(orgId!),
    enabled: !!orgId && enabled,
    staleTime: 60 * 1000,
  });

  return { deals: data ?? [], isLoading, isError, error, refetch };
}
